"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../../constants");

var util_1 = require("../util"); // Note: Comments are intentionally repeated in this file
// in the schema definitions - vs code can display these
// comments to consumers of the appropriate types if they are
// inlined in the schema definition, but this does not work
// if the comments are above the shared variables so please do not
// delete/remove them
// shared schema field definitions


var amount = {
  length: 10,
  type: constants_1.FieldType.float
};
var authorization = {
  length: 10,
  type: constants_1.FieldType.alphaNumeric
};
var creditCardNumber = {
  length: 40,
  type: constants_1.FieldType.base64
};
var creditCardExpirationDate = {
  length: 4,
  type: constants_1.FieldType.numeric
};
var echoLotteryStatus = {
  length: 3,
  type: constants_1.FieldType.numeric
};
var operatorId = {
  length: 16,
  type: constants_1.FieldType.numeric
};
var override = {
  length: 1,
  type: constants_1.FieldType.alphaNumeric
};
var promoCode = {
  length: 10,
  type: constants_1.FieldType.numeric
};
var secondaryAmount = {
  length: 10,
  type: constants_1.FieldType.float
};
var terminalId = {
  length: 12,
  type: constants_1.FieldType.alphaNumeric
};
var transactionNumber = {
  length: 12,
  type: constants_1.FieldType.numeric
};
var transactionType = {
  length: 2,
  type: constants_1.FieldType.alphaNumeric
}; // ordering is significant - do not sort these keys
// tslint:disable:object-literal-sort-keys

var CaptureExpandedFormatSchema = {
  /**
   * Transaction type
   *
   * @see TransactionType enum for transaction type information
   */
  transactionType: transactionType,

  /**
   * transaction subtype
   * always 8 for expanded format
   */
  subType: {
    length: 1,
    type: constants_1.FieldType.fixed,
    value: constants_1.TransactionSubtype.ExpandedRequestSubtype
  },

  /**
   * base-64 encoded card-number or
   * single digit indicating card type
   * (optional)
   */
  creditCardNumber: creditCardNumber,

  /**
   * date the credit card expires, in MMYY format
   */
  creditCardExpirationDate: creditCardExpirationDate,

  /**
   * amount of the transaction (in cents)
   */
  amount: amount,

  /**
   * transaction number
   * identifier for the given order
   * must be an integer
   */
  transactionNumber: transactionNumber,

  /**
   * terminal ID
   * used by MCM to determine pin pad identity
   */
  terminalId: terminalId,

  /**
   * authorization number
   */
  authorization: authorization,

  /**
   * installment indicator
   * whether this payment is being made
   * as part of a recurring payment plan
   */
  installmentIndicator: {
    length: 1,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * cvv2 indicator
   * whether a cvv2 is being provided
   * @see Cvv2Indicator
   */
  cvv2Indicator: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * cvv2 value
   */
  cvv2Value: {
    length: 4,
    type: constants_1.FieldType.numeric
  },

  /**
   * user billing zip code
   */
  zipCode: {
    length: 9,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * user billing address
   */
  billingAddress: {
    length: 35,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * name on card account
   */
  billingName: {
    length: 16,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * tax amount (in cents)
   * this will not be added to the purchase amount, it is provided
   * separately only for reporting purposes. tax should be included
   * in the value passed into the amount field
   */
  taxAmount: {
    length: 10,
    type: constants_1.FieldType.float
  },

  /**
   * tip amount (in cents)
   * tip amount is treated the same way as tax amount
   * always include tip amount in the value passed into
   * the amount field
   */
  tipAmount: {
    length: 10,
    type: constants_1.FieldType.float
  },

  /**
   * Card Program
   * More research is needed to understand what this value means
   * It is optional and its significance is unclear, possible
   * values are not provided in the technical specification
   */
  cardProgram: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * transaction date
   * provide in MMDDYY format, no delimiter
   */
  transactionDate: {
    length: 6,
    type: constants_1.FieldType.numeric
  },

  /**
   * secondary amount
   * More research is needed to understand what this value means
   * It is optional and its significance is unclear. the documentation
   * does not provide additional information on this field
   */
  secondaryAmount: secondaryAmount,

  /**
   * promo code - optional
   * appears to be used for loyalty transactions
   */
  promoCode: promoCode,

  /**
   * operator ID - optional, the ID of the operator (for reporting)
   */
  operatorId: operatorId,

  /**
   * override
   * D - Demo Mode - initiate demo transaction
   * M - Override multi-messaging for current transaction
   * Note: Only works on the linux version of MCM
   */
  override: override,

  /**
   * transaction time
   * provide in HHMMSS format, no delimiter
   */
  transactionTime: {
    length: 6,
    type: constants_1.FieldType.numeric
  },

  /**
   * Original Sequence Number
   * Note: Merchant-defined data
   */
  originalSequenceNumber: {
    length: 13,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * Customer Code/Order #
   */
  orderNumber: {
    length: 25,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * total authorization amount
   * for capturing after a pre-authorization request
   */
  totalAuthorizationAmount: {
    length: 8,
    type: constants_1.FieldType.float
  },

  /**
   * original authorization amount
   * for capturing after a pre-authorization request
   */
  originalAuthorizationAmount: {
    length: 8,
    type: constants_1.FieldType.float
  },

  /**
   * Adjustment/Surcharge Amount
   * for reporting purposes
   */
  adjustmentAndSurchargeAmount: {
    length: 8,
    type: constants_1.FieldType.float
  },

  /**
   * Food amount
   */
  foodAmount: {
    length: 10,
    type: constants_1.FieldType.float
  },

  /**
   * Merchant Defined Data field
   */
  merchantDefinedData: {
    length: 30,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * Currency Code
   */
  currencyCode: {
    length: 3,
    type: constants_1.FieldType.numeric
  },

  /**
   * Currency minor unit
   */
  currencyMinorUnit: {
    length: 2,
    type: constants_1.FieldType.numeric
  },

  /**
   * Currency exchange rate
   */
  currencyExchangeRate: {
    length: 13,
    type: constants_1.FieldType.numeric
  },

  /**
   * Secure Auth Data (Visa/MC)
   */
  secureAuthData: {
    length: 40,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * Duplicate level checking
   * Determines whether to allow suspected duplicate
   * transactions to succeed
   */
  duplicateLevelChecking: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * e-commerce goods indicator
   * Whether the purchase is for digital
   * or physical goods
   */
  eCommerceGoodsIndicator: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * @todo definitions for charge description code, duration, special program code
   */
  empty0: {
    length: 18,
    type: constants_1.FieldType.reserved
  },

  /**
   * Tax Indicator
   *
   * @see TaxIndicator
   */
  taxFlag: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * @todo add additional fields from documentation
   */
  empty1: {
    length: 48,
    type: constants_1.FieldType.reserved
  },

  /**
   * Customer Name
   */
  customerName: {
    length: 30,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * echo lottery status - usage unclear
   */
  echoLotteryStatus: echoLotteryStatus,

  /**
   * @todo add additional fields from documentation
   */
  empty2: {
    length: 82,
    type: constants_1.FieldType.reserved
  },

  /**
   * Merchant reference number
   * Can be used to provide an external identifier
   */
  merchantReferenceNumber: {
    length: 33,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * @todo add additional fields from documentation
   */
  empty3: {
    length: 89,
    type: constants_1.FieldType.reserved
  },

  /**
   * Card Info Entry Mode (when card number is provided)
   * @see CardInfoEntryIndicator
   */
  cardInfoEntryMode: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * Payment Type
   * @see PaymentTypeIndicator
   */
  paymentType: {
    length: 3,
    type: constants_1.FieldType.numeric
  },
  // append a '~' to the end of the message
  final: {
    length: 1,
    type: constants_1.FieldType.fixed,
    value: '~'
  }
};
var CaptureGiftCardValueLinkFormatSchema = {
  transactionType: {
    length: 2,
    type: constants_1.FieldType.fixed,
    value: constants_1.TransactionType.GiftCardRedemptionNoNSF
  },
  subtype: {
    length: 1,
    type: constants_1.FieldType.fixed,
    value: constants_1.TransactionSubtype.GiftCardFormat
  },
  giftCardNumber: creditCardNumber,
  userId: {
    length: 10,
    type: constants_1.FieldType.alphaNumeric
  },
  password: {
    length: 10,
    type: constants_1.FieldType.alphaNumeric
  },
  pinNumber: {
    length: 10,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * usage unclear
   */
  unit: {
    length: 10,
    type: constants_1.FieldType.alphaNumeric
  },
  amount: {
    length: 13,
    type: constants_1.FieldType.float
  },
  transactionNumber: {
    length: 17,
    type: constants_1.FieldType.alphaNumeric
  },
  terminalId: {
    length: 12,
    type: constants_1.FieldType.alphaNumeric
  },
  currencyCode: {
    length: 3,
    type: constants_1.FieldType.alphaNumeric
  },
  originalTransactionType: {
    length: 2,
    type: constants_1.FieldType.alphaNumeric
  },
  secondCardNumber: creditCardNumber,
  authorizationNumber: {
    length: 12,
    type: constants_1.FieldType.alphaNumeric
  },
  operatorId: operatorId,
  promoCode: {
    length: 10,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * this field appears twice in the documentation.
   * this is not a mistake.
   */
  operatorId2: operatorId,
  orderNumber: {
    length: 20,
    type: constants_1.FieldType.alphaNumeric
  },

  /**
   * @see GiftCardEntryMethodIndicator
   */
  cardEntryMethod: {
    length: 1,
    type: constants_1.FieldType.alphaNumeric
  },
  empty0: {
    length: 20,
    type: constants_1.FieldType.reserved
  },
  numberOfCards: {
    length: 4,
    type: constants_1.FieldType.numeric
  }
}; // gift cards have fixed transactionType so the parameters should not
// include it as a key

var isGiftCardRequest = function isGiftCardRequest(messageContent) {
  return !('transactionType' in messageContent);
};

function payment(messageContent) {
  if (isGiftCardRequest(messageContent)) {
    return util_1.prepare(messageContent, CaptureGiftCardValueLinkFormatSchema);
  }

  return util_1.prepare(messageContent, CaptureExpandedFormatSchema);
}

exports.payment = payment;

function parseAns(ansString) {
  // ans line contains <STX>ANS<STX><some response string><CR><LF>
  var _a = ansString.split(constants_1.ResponseDelimiter.STX),
      ansCode = _a[2]; // there is no documentation on the exact meaning of the ANS.
  // This value appears to be an alphanumeric identifier


  return {
    ansCode: (ansCode || '').trim()
  };
}

function parseRcp(rcpString) {
  // RCP line contains <FS>RCP<FS>RES:<resultCode><CR><LF>
  var _a = rcpString.split(constants_1.ResponseDelimiter.FS),
      resString = _a[2];

  var _b = resString.split(constants_1.ResponseDelimiter.Colon),
      resultCode = _b[1];

  return {
    result: (resultCode || '').trim()
  };
}

function parseReceipt(rawResponseString) {
  var _a = rawResponseString.split(constants_1.ResponseDelimiter.FS),
      receipt = _a[2];

  if (!receipt) return {};
  return {
    receipt: receipt.replace(constants_1.ResponseDelimiter.ETX, '')
  };
}

function parseResponse(rawResponse) {
  var responseString = rawResponse.toString(constants_1.Encoding.ascii); // first response is a string message beginning with a control char
  // \06 (ACK) is an OK

  if (responseString.startsWith(constants_1.ResponseDelimiter.ACK)) {
    return {
      rawResponse: responseString.trim(),
      responsePending: true
    };
  } // \15 (NAK) is an Error


  if (responseString.startsWith(constants_1.ResponseDelimiter.NAK)) {
    throw new Error(responseString.trim());
  } // all lines delimited by CRLF


  var lines = responseString.split(constants_1.ResponseDelimiter.CRLF);
  var ansLine = lines[0],
      rcpLine = lines[1],
      rest = lines.slice(2);
  var ans = parseAns(ansLine);
  var result = parseRcp(rcpLine);
  var receipt = parseReceipt(rest.join(constants_1.ResponseDelimiter.CRLF)); // rest of message are lines delimited by colons
  // i.e. <ResponseKey>:<ResponseValue>

  var restOfResultData = rest.reduce(function (acc, line) {
    var _a;

    var _b = line.split(constants_1.ResponseDelimiter.Colon),
        key = _b[0],
        value = _b[1];

    var readableKey = util_1.mapKeyToReadableKey(key);
    return __assign(__assign({}, acc), (_a = {}, _a[readableKey] = util_1.tryParseValue(readableKey, value), _a));
  }, {});
  return Object.assign({}, ans, result, receipt, restOfResultData, {
    rawResponse: responseString
  });
}

exports.parseResponse = parseResponse;